import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import LanguageProvider from '@locales/LanguageProvider';
import store from '@store';

import 'leaflet-polylinedecorator';

import App from './App';
import reportWebVitals from './reportWebVitals';

import '@assets/scss/index.scss';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css';

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <LanguageProvider>
                <App />
            </LanguageProvider>
        </Provider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
